const defaultTemplateArray = [
	'fulfillmentOrderId',
	'orderNumber',
	'productSkus',
	'productQuantity',
	'warehouse',
	'fulfillmentOrderStatus',
	'trackingNumbers',
	'fulfillmentOrderShipByLocalDate',
	'carrierService',
	'shippingState',
	'onHoldReason',
];

export { defaultTemplateArray };



// WEBPACK FOOTER //
// ./src/common/constants/defaultTemplateArray.js